<template>
  <div>
    <h4>{{ $t('message.trade.TotalTradeInValue.TTIV') }}</h4>
    <MobialisHorizontalRule></MobialisHorizontalRule>
    <div v-if="!!this.highListPrice && !!this.lowListPrice" class="d-flex justify-content-between">
      <span>{{ $t('message.trade.TotalTradeInValue.priceRange') }}</span>
      <span
        >{{ $n(lowListPrice, 'currencyDollars', getLanguageCodeForNumericalInternationalization) }} -
        {{ $n(highListPrice, 'currencyDollars', getLanguageCodeForNumericalInternationalization) }}</span
      >
    </div>
    <MobialisHorizontalRule v-if="!!this.highListPrice && !!this.lowListPrice"></MobialisHorizontalRule>
    <div class="d-flex justify-content-between">
      <span>{{ $t('message.trade.TotalTradeInValue.dealerRecon') }}</span>
      <span>{{ recond }}</span>
    </div>
    <MobialisHorizontalRule></MobialisHorizontalRule>
    <div class="d-flex justify-content-between">
      <span>{{ $t('message.trade.TotalTradeInValue.dealerAd') }}</span>
      <span>{{ ads }}</span>
    </div>
    <MobialisHorizontalRule></MobialisHorizontalRule>
    <div class="d-flex justify-content-between">
      <span>{{ $t('message.trade.TotalTradeInValue.avgDealHead') }}</span>
      <span>{{ overhead }}</span>
    </div>
    <MobialisHorizontalRule></MobialisHorizontalRule>
    <div class="d-flex justify-content-between">
      <span>{{ $t('message.trade.TotalTradeInValue.dealNet') }}</span>
      <span>{{ netProfit }}</span>
    </div>
    <MobialisHorizontalRule></MobialisHorizontalRule>
    <div class="d-flex justify-content-between mb-3">
      <span class="font-weight-bold">{{ $t('message.trade.TotalTradeInValue.estValueDeal') }}</span>
      <span class="font-weight-bold"
        >{{ $n(lowPrice, 'currencyDollars', getLanguageCodeForNumericalInternationalization) }} -
        {{ $n(highPrice, 'currencyDollars', getLanguageCodeForNumericalInternationalization) }}</span
      >
    </div>
    <MobialisHorizontalRule class="mb-4 mt-sm-0" />
    <div class="small mb-4">{{ $t('message.trade.TotalTradeInValue.tradesiiInfoTradalgo') }}</div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'TotalValue',
  props: {
    lowListPrice: {
      type: Number,
      default: 1234,
      required: true,
    },
    highListPrice: {
      type: Number,
      default: 5678,
      required: true,
    },
    recond: {
      type: String,
      default: '4% - 7%',
    },
    ads: {
      type: String,
      default: '2% - 5%',
    },
    overhead: {
      type: String,
      default: '5% - 8%',
    },
    netProfit: {
      type: String,
      default: '3% - 5%',
    },
    lowPrice: {
      type: Number,
      default: 1234,
      required: true,
    },
    highPrice: {
      type: Number,
      default: 5678,
      required: true,
    },
  },
  computed: {
    ...mapGetters('user', ['getLanguageCodeForNumericalInternationalization']),
  },
};
</script>

<style lang="scss" scoped>
h2 {
  font-size: 22px;
  font-weight: bold;
}
.small {
  font-size: 12px;
  color: rgb(75, 88, 99);
}
span {
  font-size: 14px;
  font-weight: normal;
}
</style>
